// Header.tsx
import React, { useState, useEffect } from "react";
import "./Header.css";

const Header: React.FC = () => {
  const [activeSection, setActiveSection] = useState<string>("");

  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll("section");
      let currentSection = "";
      let maxVisible = 0;

      sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        const visibleHeight = Math.min(
          rect.bottom,
          window.innerHeight
        ) - Math.max(rect.top, 0);

        // Ensure it's at least partially in view and not hidden below the fold
        if (visibleHeight > maxVisible && visibleHeight > 50) {
          maxVisible = visibleHeight;
          currentSection = section.id;
        }

        // If it's the last section and near the bottom of the page
        if (
          index === sections.length - 1 &&
          window.innerHeight + window.scrollY >= document.body.offsetHeight - 5
        ) {
          currentSection = section.id;
        }
      });

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Run initially on mount
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { id: "home", label: "Home" },
    { id: "skills", label: "Skills" },
    { id: "experience", label: "Experience" },
    { id: "projects", label: "Projects" },
    { id: "about", label: "About" },
    { id: "contact", label: "Contact" },
  ];

  return (
    <header className="header">
      <nav>
        <ul>
          {navItems.map(({ id, label }) => (
            <li key={id}>
              <a
                href={`#${id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(id);
                }}
                className={activeSection === id ? "active" : ""}
              >
                {label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
